module.exports = __webpack_public_path__ + "static/media/bus.f7d702bc.svg";